import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter as Router, Route } from 'react-router-dom'

import './style.css'
import Services from './views/services'
import Products from './views/products'
import About from './views/about'
import Home from './views/home'
import Facilities from './views/facilities'
import ContactUs from './views/contact-us'

const App = () => {
  return (
    <Router>
      <div>
        <Route component={Services} exact path="/services" />
        <Route component={Products} exact path="/products" />
        <Route component={About} exact path="/about" />
        <Route component={Home} exact path="/" />
        <Route component={Facilities} exact path="/facilities" />
        <Route component={ContactUs} exact path="/contact-us" />
      </div>
    </Router>
  )
}

ReactDOM.render(<App />, document.getElementById('app'))
